module.exports = __webpack_public_path__ + "img/suit-club-fill.389a8334.svg";